import { Deserializable } from "../deserializable";

export class AuthTokenEncrypted implements Deserializable{
    userId: number;
    token: string;
    role: string;
    expires: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
